module.exports = __webpack_public_path__ + "img/banco-real.d63c789a.svg";